import {
  FF_ENABLE_PRESCRIPTION_DISPENSE_LIMITS,
  FF_ENABLE_PRESCRIPTION_MANDATORY_MAXIMUM_DAILY_DOSAGES,
  FF_ENABLED_OOS_REISSUE_AUTO_ALTERNATIVE,
  FF_PRESCRIPTIONS_EXPERIMENT_PAT_PRICING_FILTER,
} from '@/constants/featureFlags';
import { useFeatureFlags } from '@/hooks';

import type { RecommendationInfo } from '../PrescriptionItemEditor.types';

/**
 * Returns a list of feature flag controlled props
 * and their default values if it doesn't exist
 */
export const usePrescriptionItemFeatureFlags = () => {
  /**
   * This function formerly returned the `prescription_recommended_products_count` and
   *  `prescription_recommendation_info` LaunchDarkly feature flag values.
   * Static values are now returned, with a future plan to change to consts in callers after the experiment .
   */

  const { flags } = useFeatureFlags();

  const enablePricingExperiment = Boolean(flags[FF_PRESCRIPTIONS_EXPERIMENT_PAT_PRICING_FILTER]);
  const autoSelectReissueAlternative = Boolean(flags[FF_ENABLED_OOS_REISSUE_AUTO_ALTERNATIVE]);
  const enableDispenseLimits = Boolean(flags[FF_ENABLE_PRESCRIPTION_DISPENSE_LIMITS]);
  const requireMaxDailyDose =
    enableDispenseLimits && Boolean(flags[FF_ENABLE_PRESCRIPTION_MANDATORY_MAXIMUM_DAILY_DOSAGES]);
  const recommendedMedicationsCount = enablePricingExperiment ? 5 : 3;
  const recommendationInfo: RecommendationInfo = {
    href: 'https://app.getguru.com/card/iByRzd4T/Prescription-assistant-guide',
    text: 'Product recommendations are based on your selections and availability criteria',
  };

  return {
    enablePricingExperiment,
    /**
     * When reissuing an out of service product, pre-select the first available alternative
     */
    autoSelectReissueAlternative,
    /** Prescription dispense limits on the prescription pad, for Herb, Dried pad items */
    enableDispenseLimits,
    /** Herb, Dried pad items must have a maximum daily dose; false while dispense limits are off */
    requireMaxDailyDose,
    recommendedMedicationsCount,
    /**
     * Information about the recommendation system
     */
    recommendationInfo,
  };
};
